import React from 'react';
import SectionHeader from '../SectionHeader';
import Infographic from '../Infographic';
import trans from '../../translations.json';

import TestsTotal from '../tests/testsTotal';
import TestsTotalTable from '../tests/testsTotal-Table';

import TestsDaily from '../tests/testsDaily';
import TestsDailyTable from '../tests/testsDaily-Table';

import TestsByPHUDaily from '../tests/testsByPHU/testsByPHUDaily';
import TestsByPHUDailyTable from '../tests/testsByPHU/testsByPHUDaily-Table';

import PercentPositive from '../tests/percentPositive';
import PercentPositiveTable from '../tests/percentPositive-Table';

import PercentPositiveTotal from '../tests/percentPositiveTotal';
import PercentPositiveTotalTable from '../tests/percentPositiveTotal-Table';

import PercentPositiveByAge from '../tests/percentPositiveByAge';
import PercentPositiveByAgeTable from '../tests/percentPositiveByAge-Table';

import Tabs from '../tabs/tabs';
import TimeToProcessTests from '../tests/timeToProccessTestsPHU';

const Testing = (props) => {
  return (
    <SectionHeader
      id="testing"
      title={trans.otp.testing}
      lastUpdated={props.lastUpdated}
      lang={props.lang}
    >
      <div className="ontario-row">
        <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
          <h3>{trans.testing.titleA[props.lang]}</h3>
          <Tabs
            lang={props.lang}
            default="newCases"
            newCases={
              <Infographic
                id="TotalPositiveTestsDaily"
                lang={props.lang}
                bar={
                  <TestsDaily
                    lang={props.lang}
                    chartTitle={trans.testingDaily.title[props.lang]}
                  />
                }
                table={<TestsDailyTable lang={props.lang} />}
                width="default"
              />
            }
            totalCases={
              <Infographic
                id="TotalPositiveTests"
                lang={props.lang}
                bar={
                  <TestsTotal
                    lang={props.lang}
                    chartTitle={trans.testingTotal.title[props.lang]}
                  />
                }
                table={<TestsTotalTable lang={props.lang} />}
                width="default"
              />
            }
          />
            <p
              dangerouslySetInnerHTML={{
                __html: trans.general.dataSourcePDNOC[props.lang],
              }}
            ></p>
        </div>
      </div>
      <div className="ontario-row">
        <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
          <h3>{trans.testing.titleD[props.lang]}</h3>
          <Tabs
            lang={props.lang}
            default="newCases"
            newCases={
              <Infographic
                id="TotalPositiveTestsDaily"
                lang={props.lang}
                bar={
                  <PercentPositive
                    lang={props.lang}
                    chartTitle={trans.testingDaily.title[props.lang]}
                  />
                }
                table={<PercentPositiveTable lang={props.lang} />}
                width="default"
              />
            }
            totalCases={
              <Infographic
                id="TotalPositiveTests"
                lang={props.lang}
                bar={
                  <PercentPositiveTotal
                    lang={props.lang}
                    chartTitle={trans.testingTotal.title[props.lang]}
                  />
                }
                table={
                  <PercentPositiveTotalTable lang={props.lang} />
                }
                width="default"
              />
            }
          />
            <p
              dangerouslySetInnerHTML={{
                __html: trans.general.dataSourcePDNOC[props.lang],
              }}
            ></p>
        </div>
      </div>

      <div className="ontario-row">
        <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
          <h3>{trans.testing.titleE[props.lang]}</h3>
          <Infographic
            id="TotalTestsDaily"
            lang={props.lang}
            bar={
              <PercentPositiveByAge
                lang={props.lang}
                chartTitle={trans.testingDaily.title[props.lang]}
              />
            }
            table={<PercentPositiveByAgeTable lang={props.lang} />}
            width="default"
          />
          <p
            dangerouslySetInnerHTML={{
              __html: trans.general.dataSourceOLIS[props.lang],
            }}
          ></p>
        </div>
      </div>
      <div className="ontario-row">
        <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
          <h3>{trans.testing.titleF[props.lang]}</h3>
          {/* <p>{trans.testing.desc8[props.lang]}</p> */}
          <Infographic
            id="TestsByPHUDaily"
            lang={props.lang}
            bar={
              <TestsByPHUDaily
                lang={props.lang}
                chartTitle={trans.testingDaily.title[props.lang]}
              />
            }
            table={<TestsByPHUDailyTable lang={props.lang} />}
            width="default"
          />
        </div>
      </div>

      <div className="ontario-row">
        <div className="ontario-columns ontario-small-12 ontario-medium-12 ontario-margin-bottom-32-!">
          <h3>{trans.testing.titleProcessTests[props.lang]}</h3>
          <TimeToProcessTests lang={props.lang} />
          <p
            dangerouslySetInnerHTML={{
              __html: trans.general.dataSourceOLIS[props.lang],
            }}
          ></p>
        </div>
      </div>
    </SectionHeader>
  );
};

export default Testing;
